import { success } from "toastr";
import {
  FETCH_SKILLS_REQUEST,
  FETCH_SKILLS_SUCCESS,
  FETCH_SKILLS_FAILURE,
  SAVE_SKILL_REQUEST,
  SAVE_SKILL_SUCCESS,
  SAVE_SKILL_FAILURE,
  DELETE_SKILL_REQUEST,
  DELETE_SKILL_SUCCESS,
  DELETE_SKILL_FAILURE,
  GET_EMPLOYEE_SKILLS_REQUEST,
  GET_EMPLOYEE_SKILLS_SUCCESS,
  SAVE_EMPLOYEE_SKILLS_SUCCESS,
  GET_EMPLOYEE_SKILLS_FAILURE,
  SAVE_EMPLOYEE_SKILLS_FAILURE,
  SAVE_EMPLOYEE_SKILLS_REQUEST,
} from "./actionTypes";

const initialState = {
  loading: false,
  skillsList: [],
  data: null,
  deleteResponse: null,
  error: null,
  success: false,
};

const skillMasterReducer = (state = initialState, action) => {
  switch (action.type) {

    /* Fetch */
    case FETCH_SKILLS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_SKILLS_SUCCESS:
      return {
        ...state,
        loading: false,
        skillsList: action.payload.data || [],
        success: false,
      };

    case FETCH_SKILLS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* Save */
    case SAVE_SKILL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case SAVE_SKILL_SUCCESS:
      return { ...state, loading: false, data: action.payload, success: true };

    case SAVE_SKILL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* Delete */
    case DELETE_SKILL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case DELETE_SKILL_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteResponse: action.payload,
        success: true,
      };

    case DELETE_SKILL_FAILURE:
      return { ...state, loading: false, error: action.payload };


    case GET_EMPLOYEE_SKILLS_REQUEST:
    case SAVE_EMPLOYEE_SKILLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case GET_EMPLOYEE_SKILLS_SUCCESS:
      return {
        ...state,
        loading: false,
        skillsList: action.payload,
        success: false,
      };

    case SAVE_EMPLOYEE_SKILLS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case GET_EMPLOYEE_SKILLS_FAILURE:
    case SAVE_EMPLOYEE_SKILLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default skillMasterReducer;
